import type { TFullTranslationsChange } from "./full-translations-session.models";

/**
 * The full catalogue follows the session, but only when the session changes: before the session check the
 * logged-in flag starts out false, and dropping the catalogue then would empty its cache on every reload.
 */
export const getFullTranslationsChange = ({
  wasLoggedIn,
  isLoggedIn,
}: {
  wasLoggedIn: boolean;
  isLoggedIn: boolean;
}): TFullTranslationsChange | undefined => {
  if (isLoggedIn === wasLoggedIn) {
    return undefined;
  }

  return isLoggedIn ? "enable" : "disable";
};
